// 코드관리(SY07) 화면 상수 — 화면(index.tsx) 배선이 쓰는 문구·계정 판정. UI(컬럼·필터)는 컨덕터 생성본이 정본이라 여기 두지 않는다.
import type { core } from '@musinsa/pbo-core'

/** 목록 구간 크기 = BE size 상한 — Pageable 기본 max-page-size(2000, moms-be 설정 없음). 넘겨 보내면 오류 없이 2000건으로 잘린다(LOGISPRD-15271). */
export const SY07_FETCH_CHUNK_SIZE = 2000

export const MESSAGES = {
  noShipper: '화주명을 선택해 주세요.',
  noSelection: '저장할 행을 선택해 주세요.',
  /** 필수 칸 제목은 화면관리 설정을 반영한 별표에서 온다(LOGISPRD-17254) */
  requiredCells: (titles: string[]) => `${titles.join('·')} 칸은 필수입니다.`,
  shipperLocked: '다른 화주의 코드는 저장할 수 없습니다.',
  deleteShipperLocked: '다른 화주의 코드는 삭제할 수 없습니다.',
  shipperLoadFailed: '화주 목록을 불러오지 못했습니다. 새로고침한 뒤 다시 시도해 주세요.',
  /** 행별 순차 처리 중 실패 — 실패 지점에서 멈추므로 앞의 done 건은 이미 반영됐다. */
  partialFailed: (total: number, done: number, reason: string) => `${total}건 중 ${done}건 반영 후 실패했습니다. ${reason}`,
} as const

/** 화면관리 그리드 설정(LOGISPRD-17254) — 표 id(생성본 columnLayout 키) → gridCd(docs/conventions/grid-code.md, 1.0 SY07_HEAD 짝). 개인 컬럼 배치 저장도 같은 값을 쓴다 */
export const TABLE_ID = 'sy07Table'
export const GRID_CDS = { [TABLE_ID]: 'SY10_HEAD' } as const

/** BE `CommonCodeSaveRequest` 가 @NotBlank 로 거부하는 칸 — 화면관리 설정이 필수를 꺼도 [저장] 이 막는다. 코드그룹(codeGrp)은 비어도 BE 가 받는다 */
export const BE_REQUIRED_KEYS: ReadonlySet<string> = new Set(['SPR_NM', 'CODE', 'CODE_DESC'])

/** [저장] 필수 검사 후보 — 저장 본문에 실리는 편집 칸. required 는 화면관리 설정이 없을 때 값(생성본 별표·이 변경 전 고정 검사와 같다) */
export const SAVE_REQUIRED_CANDIDATES: core.CoreColumnType[] = [
  { dataIndex: 'SPR_NM', title: '화주코드', required: true },
  { dataIndex: 'CODE_GRP', title: '코드그룹', required: true },
  { dataIndex: 'CODE', title: '코드', required: true },
  { dataIndex: 'CODE_DESC', title: '코드내용', required: true },
]
